import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const HeaderItem = styled.div`
    cursor: default;

    flex-shrink: 0;

    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    color: ${Colors.Black.V100};
`;
